export const AGE_GATE_PHASE = {
	PROMPT: 'prompt',
	BLOCKED: 'blocked',
};

export const AGE_GATE_DECLINE_REDIRECT_URL = 'https://www.google.com';

export const AGE_GATE_TERMS_HREF = '/SoftAI regulamin terms of use.pdf';
export const AGE_GATE_PRIVACY_HREF = '/PRIVACY POLICY.pdf';
